// User preferences localStorage'da tutulur (per-browser).

const KEY_RICH_TWITTER = 'pref.richTwitter'

export function getRichTwitter(): boolean {
  // Default true — rich preview kullanıcı istemediği zaman kapatabilir
  const v = localStorage.getItem(KEY_RICH_TWITTER)
  return v === null ? true : v === '1'
}

export function setRichTwitter(on: boolean) {
  localStorage.setItem(KEY_RICH_TWITTER, on ? '1' : '0')
  // Aynı tab içinde update için event tetikle
  window.dispatchEvent(new Event('prefs:richTwitter'))
}
